import { Component, OnInit } from '@angular/core';
import { MatDialogCloseEvent, Role } from '../../../const';
import { SchoolService } from '../school.service';
import { DtoSchool } from '../../../models/school.model';
import { EditSchoolComponent } from '../../user-center/edit-school/edit-school.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { UserRoles } from '../../../models/mat-account.model';
import { MatAccountService } from '../../mat-account/mat-account.service';
import { Users } from '../../../models/user-center.model';

@Component({
  selector: 'app-school-basic-details',
  templateUrl: './school-basic-details.component.html'
})
export class SchoolBasicDetailsComponent implements OnInit {

  userRole: string[] = [];
  roles = Role;
  userEmail: string = "";
  roleName: string[] = [];
  school: DtoSchool = {} as DtoSchool;
  accountAdminList: Users[] = [];

  constructor(private schoolService: SchoolService, private dialog: MatDialog,
              private toasterService: ToastrService, private matAccountService: MatAccountService
  ){}
  ngOnInit(): void {
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userRole?.forEach(element => {
      this.roleName.push(this.getRoleNameByValue(Role, element)!);
    });
    this.getSchoolData(this.userEmail);
    this.getAccountAdminDetails();
  }

  getAccountAdminDetails() {
    let payload: UserRoles = {} as UserRoles;
    payload.userRole = this.userRole;
    this.matAccountService.getAccountAdminDetails(this.userRole).subscribe((response: Users[] | any) => {
      this.accountAdminList = response;
    }, (err: HttpErrorResponse) => {
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }
  
  getSchoolData(emailId: string){
    this.schoolService.getSchoolData(emailId).subscribe((response: DtoSchool)=>{
      this.school = response;
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  editSchool(school: DtoSchool){
    this.dialog.open(EditSchoolComponent,{
      width: '1000px',
      data: { school: school, isEdit: true, accountAdminList: this.accountAdminList }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.getSchoolData(this.userEmail);
      }
    })
  }

  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }
}
